import { useState, useEffect } from 'react';
import { getActiveCities, City } from '../services/cityService';
import { cities as defaultCities } from '../data/events';

export const useCities = () => {
  const [cities, setCities] = useState<City[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        setLoading(true);
        const fetchedCities = await getActiveCities();
        
        if (fetchedCities.length > 0) {
          setCities(fetchedCities);
        } else {
          // If no cities in Firestore, create default cities from static data
          const defaultCitiesList = defaultCities.map(city => ({
            id: city,
            name: city,
            active: true
          }));
          setCities(defaultCitiesList);
        }
      } catch (err) {
        console.error('Error fetching cities:', err);
        setError('Failed to load cities');
        
        // Fallback to default cities
        const defaultCitiesList = defaultCities.map(city => ({
          id: city,
          name: city,
          active: true
        }));
        setCities(defaultCitiesList);
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, []);

  return { cities, loading, error };
};